import { useState } from "react";
import { ChevronDown } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { FAQS } from "../data/site";

function FaqItem({ item, index }) {
    const [open, setOpen] = useState(false);
    return (
        <div className="border-b border-amber-500/12 last:border-b-0">
            <button
                data-testid={`faq-question-${index}`}
                aria-expanded={open}
                onClick={() => setOpen((v) => !v)}
                className="flex w-full items-center justify-between gap-4 py-5 text-left"
            >
                <span
                    className={`font-serif text-lg transition-colors ${
                        open ? "text-amber-300" : "text-amber-100"
                    }`}
                >
                    {item.q}
                </span>
                <ChevronDown
                    className={`h-5 w-5 shrink-0 text-amber-400 transition-transform duration-300 ${
                        open ? "rotate-180" : ""
                    }`}
                />
            </button>
            <div
                className="grid transition-all duration-300 ease-out"
                style={{ gridTemplateRows: open ? "1fr" : "0fr" }}
            >
                <div className="overflow-hidden">
                    <p
                        data-testid={`faq-answer-${index}`}
                        className="pb-6 pr-8 text-sm leading-relaxed text-amber-100/65"
                    >
                        {item.a}
                    </p>
                </div>
            </div>
        </div>
    );
}

export default function Faqs() {
    return (
        <div data-testid="faqs-page" className="pb-28">
            <PageHeader
                testid="faqs-header"
                breadcrumb="FAQs"
                title="Asked before you did"
                number="07"
                label="FAQs"
                heading="The questions everyone asks before they call"
            >
                <div className="mt-10 rounded-3xl border border-amber-500/15 bg-[#1F1510]/50 px-7 py-2 sm:px-9">
                    {FAQS.map((item, i) => (
                        <FaqItem key={item.q} item={item} index={i} />
                    ))}
                </div>
            </PageHeader>
        </div>
    );
}
